import BASE_RULE from '../baseRule';
import {SearchTypeCustom} from './constants';
import {CustomRule} from './types';

export const customRuleDefaults: CustomRule = {
	...BASE_RULE,
	elementType: SearchTypeCustom,
	elementSubType1: 0,
};

export default customRuleDefaults;
